import { render } from "./FrontendView.vue?vue&type=template&id=bbf184f6&scoped=true&ts=true"
import script from "./FrontendView.vue?vue&type=script&lang=ts"
export * from "./FrontendView.vue?vue&type=script&lang=ts"

import "./FrontendView.vue?vue&type=style&index=0&id=bbf184f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf184f6"]])

export default __exports__